module.exports = __webpack_public_path__ + "static/media/features-surface-ad6.9b4ba658.png";